module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Bold-ba8c0be3b1133c19a3446ffbc58775f2.woff2";